import { get, post } from '@elementary/common-ui/utils/http';
import {
  AgentCodeTestConfigChange,
  AgentTestOperation,
} from '@elementary/common-ui/types';
import { normalizeCodeTestParams } from '@elementary/common-ui/utils/codeTestConfig';
import {
  AiTestConfigurationResponse,
  DeleteTestApi,
  DeleteSingularTestApi,
  TestTemplateMetadata,
  TestTemplateData,
} from 'shared/types';

export const deleteTests = (
  args: DeleteTestApi,
  envId: string,
  ticketId?: string,
) =>
  post(
    `${
      import.meta.env.VITE_API_BASE_URL
    }/environments/${envId}/pull-requests/delete_generic_tests`,
    {
      data: { delete_tests: args },
      ...(ticketId ? { ticket_id: ticketId } : {}),
    },
  );

export const deleteSingularTests = (
  args: DeleteSingularTestApi,
  envId: string,
  ticketId?: string,
) =>
  post(
    `${
      import.meta.env.VITE_API_BASE_URL
    }/environments/${envId}/pull-requests/delete_singular_tests`,
    {
      data: args,
      ...(ticketId ? { ticket_id: ticketId } : {}),
    },
  );

export const getTestTemplates = (
  appliesTo: 'column' | 'table' | undefined,
  envId: string,
): Promise<{ test_templates: TestTemplateMetadata[] }> =>
  get(
    `${
      import.meta.env.VITE_API_BASE_URL
    }/test-management/${envId}/test-templates`,
    {
      applies_to: appliesTo,
    },
  );

export const getTestTemplateData = (
  testName: string,
  envId: string,
): Promise<TestTemplateData> =>
  get(
    `${
      import.meta.env.VITE_API_BASE_URL
    }/test-management/${envId}/test-templates/${testName}`,
  );

export const generateTestConfiguration = (
  envId: string,
  assetId: string,
  testName: string,
  yamlConfig: string,
  resourceType: 'table' | 'column',
  userInput?: string,
): Promise<AiTestConfigurationResponse> =>
  post(
    `${
      import.meta.env.VITE_API_BASE_URL
    }/test-management/${envId}/ai-test-configuration`,
    {
      resource_unique_id: assetId,
      full_name: testName,
      yaml_config: yamlConfig,
      resource_type: resourceType,
      user_input: userInput,
    },
  );

export const previewCodeTestPlanYaml = (
  envId: string,
  operation: AgentTestOperation,
  changes: AgentCodeTestConfigChange[],
): Promise<{ changes: AgentCodeTestConfigChange[] }> =>
  post(
    `${
      import.meta.env.VITE_API_BASE_URL
    }/test-management/${envId}/preview-code-test-plan-yaml`,
    {
      operation,
      changes: changes.map((change) => ({
        ...change,
        params: normalizeCodeTestParams(change.params),
      })),
    },
  );
